<template>
  <div class="idCardUploadWay-container">
    <div class="idCardUploadWay-title">请选择上传方式</div>
    <div class="idCardUploadWay-floor-btn camera-btn" @click="selectCamera">
      开始拍摄
    </div>
    <div class="idCardUploadWay-floor-btn photo-btn" @click="selectPhoto">
      从相册上传
    </div>
  </div>
</template>
  <script>
export default {
  name: "idCardUploadWay",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    selectCamera() {
      this.$emit("doComfirm");
    },
    selectPhoto() {
      this.$emit("doCancel");
    },
  },
};
</script>
  <style >
.idCardUploadWay-container {
  background: #fff;
  width: 80%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  padding: 1rem 0.5rem;
}
.idCardUploadWay-title {
  font-size: 1rem;
  /* padding: 0.5rem 0; */
  margin-bottom: 1rem;
}
.idCardUploadWay-floor-btn {
  width: 80%;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  border-radius: 5px;
}
.camera-btn {
  background-color: var(--el-color-primary);
  color: #fff;
}
.photo-btn {
  margin-top: 1rem;
  border: 1px solid var(--el-color-primary);
  color: var(--el-color-primary);
}
</style>
